import ServiceCard from '../components/ServiceCard.jsx';
import AnimatedWrapper from '../components/AnimatedWrapper.jsx';

const services = [
  {
    title: 'Scannable Artifacts & Smart Checkpoints',
    stat: '76% of consumers prefer store with smart technology',
    icon: 'artifact',
    points: [
      'Menus, catalogs, FAQs, instant payments and more, triggered from artistic, interactive pieces',
      'Data-driven content updates with multilingual support and seasonal storytelling',
    ],
  },
  {
    title: 'Responsive Signage, Sound & Light Design',
    stat: 'Repeat visits up 30% with interactive media',
    icon: 'lighting',
    points: [
      'Responsive signage that draws customers and increases dwell time',
      'Automated triggers designed with sensory specialists to keep guests exploring',
    ],
  },
  {
    title: 'Sensors, Alerts & Analytics',
    stat: 'Loss prevention improves up to 40% with IoT sensing',
    icon: 'sensor',
    points: [
      'Environmental, occupancy, and asset sensors with instant notifications',
      'Executive analytics tying experiential KPIs to sales, staffing, and other goals',
    ],
  },
];

const Services = () => {
  return (
    <div className="page services-page">
      <AnimatedWrapper direction="up" delay={0}>
        <section className="section-heading">
          <p className="eyebrow">Services</p>
          <h1>IoT systems designed like installations, tuned like intelligence hubs</h1>
          <p>
            Your visual identity is a powerful, memorable hook. Now, let's ground it in cognitive science and clear conversion paths to turn that 'vibe' into a client-acquisition machine.
          </p>
        </section>
      </AnimatedWrapper>
      <div className="services-grid">
        {services.map((service, i) => (
          <AnimatedWrapper key={service.title} direction="up" delay={i * 120}>
            <ServiceCard {...service} />
          </AnimatedWrapper>
        ))}
      </div>
      <AnimatedWrapper direction="up" delay={services.length * 120}>
        <section className="service-highlight">
        <h2>Why invest now?</h2>
        <ul>
          <li>
            <strong>Staff support:</strong> Leveraging IoT devices has been found to provide support to staff, automating repetitive tasks and freeing them up for other tasks. Guests benefit from quicker more efficient service, feeding into better guest satisfaction and lower operational costs.<sup>
              <a
                href="https://www.hospitalitynet.org/news/4128836.html"
                target="_blank"
                rel="noreferrer"
              >
                [source]
              </a>
            </sup>
          </li>
          <li>
            <strong>Customer curiosity:</strong> Experiential commerce studies reveal interactive landmarks deliver a proven ROI, with 71% of brands reporting positive returns and 38% seeing an ROI increase of over 20%.<sup>
              <a
                href="https://www.singlegrain.com/digital-marketing/how-immersive-experiences-are-revolutionizing-marketing/"
                target="_blank"
                rel="noreferrer"
              >
                [source]
              </a>
            </sup>
          </li>
          <li>
            <strong>Sustainability:</strong> IoT devices demonstrate a strong sustainability and guest experience ROI. With near-40% reduction in energy usage, which translates to sizable cost savings annually (tens of thousands of dollars in utility bills), smart devices offer a tangible return on tech investment.<sup>
              <a
                href="https://www.svconline.com/markets/entertainment/watch-avoip-case-study-intel-iot-and-poe-at-sinclair-hotel"
                target="_blank"
                rel="noreferrer"
              >
                [source]
              </a>
            </sup>
          </li>
        </ul>
      </section>
      </AnimatedWrapper>
    </div>
  );
};

export default Services;
